export const USER_LOGIN = 'USER_LOGIN'
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS'
export const USER_LOGIN_FAILED = 'USER_LOGIN_FAILED'
export const USER_LOGOUT = 'USER_LOGOUT'
export const USER_ROLE_CHANGE = 'USER_ROLE_CHANGE'
export const USER_OPERATING_UNIT_CHANGE = 'USER_OPERATING_UNIT_CHANGE'
export const DACH_USER_ROLE_CHANGE = 'DACH_USER_ROLE_CHANGE'

export const CREATE_ACCESS_TOKEN = 'CREATE_ACCESS_TOKEN'
export const SET_ACCESS_TOKEN = 'SET_ACCESS_TOKEN'

export const FORM_LOGIN = 'login'

export const SET_TOKENS = 'SET_TOKENS'
export const SET_URLS = 'SET_URLS'
export const SET_REDIRECT_URI = 'SET_REDIRECT_URI'

export const GET_REDIRECT_URL = 'GET_REDIRECT_URL'
export const GET_REDIRECT_URL_SUCCESS = 'GET_REDIRECT_URL_SUCCESS'
export const GET_REDIRECT_URL_FAILED = 'GET_REDIRECT_URL_FAILED'

export const GET_AZURE_REDIRECT_URL = 'GET_AZURE_REDIRECT_URL'
export const GET_AZURE_REDIRECT_URL_SUCCESS = 'GET_AZURE_REDIRECT_URL_SUCCESS'
export const GET_AZURE_REDIRECT_URL_FAILED = 'GET_AZURE_REDIRECT_URL_FAILED'

export const ACTIVATION_CUSTOMER = 'ACTIVATION_CUSTOMER'
export const ACTIVATION_CUSTOMER_SUCCESS = 'ACTIVATION_CUSTOMER_SUCCESS'
export const ACTIVATION_CUSTOMER_FAILED = 'ACTIVATION_CUSTOMER_FAILED'

export const ACTIVATION_FROM_BUTTON_CLICK = 'ACTIVATION_FROM_BUTTON_CLICK'
export const ACTIVATION_FROM_BUTTON_CLICK_SUCCESS = 'ACTIVATION_FROM_BUTTON_CLICK_SUCCESS'
export const ACTIVATION_FROM_BUTTON_FAILED = 'ACTIVATION_FROM_BUTTON_FAILED'
